import { camelCase } from 'lodash-es';

import { CityWithJobCount } from '@pflegia/data-access';
import { JobTitle } from '@pflegia/types/api/job-title/job-title-type';
import { JOBS } from '@pflegia/ui/pflegia/constants/routes';
import { normalizeJobsParams } from '@pflegia/util/common/normalize-jobs-params';

import deJobTitles from '@public/locales/de/jobTitles.json';

import ClusterButton from '@shared/components/cluster-button/ClusterButton';

import { SectionTitle } from '../section/Section.component';

const MAX_JOB_TITLES_TO_SHOW = 5;

export type NavigationClusterProps = {
  alternativeJobTitlesByPriority?: JobTitle[] | null;
  city?: string | null;
  nearbyCities?: CityWithJobCount[];
};

const NavigationCluster = ({ alternativeJobTitlesByPriority, city, nearbyCities }: NavigationClusterProps) => {
  const keyPrefix = 'jobDetails:internalLinkingClusters';
  const jobTitles = alternativeJobTitlesByPriority
    ?.filter(jobTitle => jobTitle.jobCount && jobTitle.jobCount > 0)
    .map(jobTitle => jobTitle.title)
    .slice(0, MAX_JOB_TITLES_TO_SHOW);

  if ((!nearbyCities || nearbyCities.length === 0) && jobTitles?.length === 0) return null;

  return (
    <>
      {nearbyCities && nearbyCities.length > 0 && (
        <div className='mt-8'>
          <SectionTitle titleKey={`${keyPrefix}.citiesTitle`} id='cities' />
          <div className='mb-4 flex flex-wrap'>
            {nearbyCities.map(({ city: nearbyCity }) => (
              <ClusterButton
                key={nearbyCity}
                label={nearbyCity}
                href={`${JOBS}/${normalizeJobsParams(nearbyCity)}`}
                testId={`city-${nearbyCity}`}
              />
            ))}
          </div>
        </div>
      )}

      {jobTitles && jobTitles.length > 1 && (
        <div className='mt-8'>
          <SectionTitle titleKey={`${keyPrefix}.moreJobsTitle`} id='moreJobs' />
          <div className='flex flex-wrap justify-center md:mb-16'>
            {jobTitles.map(jobTitle => {
              const jobTitleKey = camelCase(jobTitle) as keyof typeof deJobTitles;
              const translatedJobTitle = deJobTitles[jobTitleKey] ?? jobTitle;
              const location = city ? `/${normalizeJobsParams(city)}` : '';
              return (
                <ClusterButton
                  key={jobTitle}
                  label={translatedJobTitle}
                  href={`${JOBS}/${normalizeJobsParams(translatedJobTitle)}${location}`}
                  testId={`jobPosition-${jobTitle}`}
                  isFullWidth
                />
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default NavigationCluster;
